'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface InsurancePlan {
  id: string;
  name: string;
  coverage: string[];
  price: number;
  recommended: boolean;
}

interface InsuranceCardProps {
  plans: InsurancePlan[];
  currency: string;
}

export default function InsuranceCard({ plans, currency }: InsuranceCardProps) {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);

  return (
    <div className="bg-card rounded-xl shadow-brand p-6 border border-border">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-trust-green/10 rounded-lg flex items-center justify-center">
          <Icon name="ShieldCheckIcon" size={20} className="text-trust-green" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-lg text-foreground">
            Travel Insurance
          </h3>
          <p className="text-sm text-muted-foreground">
            Protect your journey
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`p-4 rounded-lg border-2 transition-all duration-300 ${
              selectedPlan === plan.id
                ? 'border-trust-green bg-trust-green/5' :'border-border hover:border-trust-green/50'
            }`}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setSelectedPlan(plan.id)}
                  className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${
                    selectedPlan === plan.id
                      ? 'border-trust-green bg-trust-green' :'border-border'
                  }`}
                >
                  {selectedPlan === plan.id && (
                    <Icon name="CheckIcon" size={12} className="text-white" />
                  )}
                </button>
                <div>
                  <p className="font-heading font-semibold text-foreground">
                    {plan.name}
                  </p>
                  {plan.recommended && (
                    <span className="inline-block mt-1 px-2 py-0.5 bg-accent/10 text-accent text-xs font-semibold rounded">
                      Recommended
                    </span>
                  )}
                </div>
              </div>
              <p className="font-heading font-bold text-lg text-primary">
                {currency}{plan.price}
              </p>
            </div>

            <ul className="space-y-2">
              {plan.coverage.map((item, index) => (
                <li key={index} className="flex items-start space-x-2 text-sm text-muted-foreground">
                  <Icon name="CheckCircleIcon" size={16} className="text-trust-green mt-0.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {selectedPlan && (
        <button className="w-full mt-6 px-6 py-3 bg-trust-green text-white font-heading font-semibold rounded-lg hover:bg-[#38A169] transition-colors duration-300">
          Add Insurance to Booking
        </button>
      )}
    </div>
  );
}